import React from 'react';
import styles from './AttendanceGraph.module.css';

interface AttendanceGraphProps {
  data: any;
}

const AttendanceGraph: React.FC<AttendanceGraphProps> = ({ data }) => {
  if (!data || !data.course) return null
  const sessions = data.course.sessions;

  // Function to calculate the percentage of each attendance status
  const getStatusPercentages = (attendance: any[]) => {
    const total = attendance.length;
    if (total === 0) return { present: 0, absent: 0, pending: 0, other: 0 };

    const present = attendance.filter(a => a.status === 'PRESENT').length;
    const absent = attendance.filter(a => a.status === 'ABSENT').length;
    const pending = attendance.filter(a => a.status === 'PENDING').length;
    const other = attendance.filter(a => !['PRESENT', 'ABSENT', 'PENDING'].includes(a.status)).length;

    return {
      present: (present / total) * 100,
      absent: (absent / total) * 100,
      pending: (pending / total) * 100,
      other: (other / total) * 100,
    };
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.plot}>
        <div className={styles.yAxis}>
          <span>100%</span>
          <span>75%</span>
          <span>50%</span>
          <span>25%</span>
          <span>0%</span>
        </div>
        <div className={styles.bars}>
          {sessions.map((session: any) => {
            const { present, other, absent, pending } = getStatusPercentages(
              session.attendance.filter((a: any) => !a.isTeacher)
            );
            return (
              <div
                className={styles.column}
                key={session.id}
                title={`Present ${Math.round(present)}% · Absent ${Math.round(absent)}% · Other ${Math.round(other)}% · Pending ${Math.round(pending)}%`}
              >
                <div className={`${styles.segment} ${styles.pending}`} style={{ height: `${pending}%` }}></div>
                <div className={`${styles.segment} ${styles.absent}`} style={{ height: `${absent}%` }}></div>
                <div className={`${styles.segment} ${styles.other}`} style={{ height: `${other}%` }}></div>
                <div className={`${styles.segment} ${styles.present}`} style={{ height: `${present}%` }}></div>
              </div>
            );
          })}
        </div>
      </div>

      <div className={styles.xAxisLabel}>Sessions (oldest → newest)</div>

      <div className={styles.legend}>
        <span className={styles.legendItem}><span className={`${styles.swatch} ${styles.present}`}></span> Present</span>
        <span className={styles.legendItem}><span className={`${styles.swatch} ${styles.absent}`}></span> Absent</span>
        <span className={styles.legendItem}><span className={`${styles.swatch} ${styles.other}`}></span> Other</span>
        <span className={styles.legendItem}><span className={`${styles.swatch} ${styles.pending}`}></span> Pending</span>
      </div>
    </div>
  );
};

export { AttendanceGraph };
